<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil">
            <p>建站服务</p>
            <a-row :gutter="24">
                <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">内容管理系统</div>
                            <div class="i-content">简单智能管理的管理多格式内容</div>
                            <a-button>点击进入</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s1.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/1.png" alt="">
                        </div>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">城市分站</div>
                            <div class="i-content">一个网站多个分站，内容更多样</div>
                            <a-button>点击进入</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s2.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/1.png" alt="">
                        </div>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">外链体系</div>
                            <div class="i-content">推广见效快，平台数据积累高效</div>
                            <a-button>点击进入</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s3.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/1.png" alt="">
                        </div>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">ECMS助手</div>
                            <div class="i-content">在线快速查询，查排名</div>
                            <a-button>点击进入</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s4.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/1.png" alt="">
                        </div>
                    </div>
                </a-col>
            </a-row>

            <p>搜索引擎推广</p>
            <a-row :gutter="24">
                <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">SEO推广</div>
                            <div class="i-content">快速改进网站在搜索引擎中的关键词自然排名</div>
                            <a-button>点击进入</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s5.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/1.png" alt="">
                        </div>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">AI快速推广</div>
                            <div class="i-content">快速排名，霸占百度首页，获取优质客户</div>
                            <a-button>点击进入</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s6.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/2.png" alt="">
                        </div>
                    </div>
                </a-col>
            </a-row>

            <p>小程序推广</p>
            <a-row :gutter="24">
                <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">百度小程序</div>
                            <div class="i-content">推广优先主动享受流量分发，红利巨大</div>
                            <a-button>点击进入</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s12.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/1.png" alt="">
                        </div>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">微信小程序</div>
                            <div class="i-content">适用范围广泛，推广方式灵活</div>
                            <a-button @click="openmodal">申请开通</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s13.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/2.png" alt="">
                        </div>
                    </div>
                </a-col>
            </a-row>

            <p>付费广告</p>
            <a-row :gutter="24">
                <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">付费广告：抖音</div>
                            <div class="i-content"></div>
                            <a-button>申请开通</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s7.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/2.png" alt="">
                        </div>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">付费广告：头条</div>
                            <div class="i-content"></div>
                            <a-button>申请开通</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s8.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/2.png" alt="">
                        </div>
                    </div>
                </a-col>
                 <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">付费广告：UC</div>
                            <div class="i-content"></div>
                            <a-button>申请开通</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s9.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/2.png" alt="">
                        </div>
                    </div>
                </a-col>
                 <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">付费广告：搜狗</div>
                            <div class="i-content"></div>
                            <a-button>点击进入</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s10.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/2.png" alt="">
                        </div>
                    </div>
                </a-col>
                 <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">付费广告：360</div>
                            <div class="i-content"></div>
                            <a-button>点击进入</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s11.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/2.png" alt="">
                        </div>
                    </div>
                </a-col>
                 <a-col :span="8">
                    <div class="service">
                        <div class="item-left">
                            <div class="i-title">付费广告：百度</div>
                            <div class="i-content"></div>
                            <a-button>点击进入</a-button>
                        </div>
                        <div class="item-right">
                            <img src="../../../static/s12.png" alt="">
                        </div>
                        <div class="tip">
                            <img src="../../../static/2.png" alt="">
                        </div>
                    </div>
                </a-col>
            </a-row>
        </div>

        <!-- 开通服务 -->
        <a-modal
        class="pwdmodal"
        title="申请开通"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="smodal"
        :confirm-loading="confirmLoading"
        @ok="open"
        @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label  class="required-icon">公司名称：</label>
                </a-col>
                <a-col :span="16">
                    <a-input placeholder="请输入公司名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">站点域名：</label>
                </a-col>
                <a-col :span="16">
                    <a-input  placeholder="请输入站点域名"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">申请开通：</label>
                </a-col>
                <a-col :span="16">
                    <a-input  placeholder=""></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">联系人：</label>
                </a-col>
                <a-col :span="16">
                    <a-input  placeholder=""></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">联系电话：</label>
                </a-col>
                <a-col :span="16">
                    <a-input  placeholder="请输入联系电话"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>备注：</label>
                </a-col>
                <a-col :span="16">
                      <a-textarea placeholder="" :rows="2" />
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>

export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '开通服务'},
            ],
            smodal:false,
            confirmLoading:false,
        }
    },
    methods:{
        handleCancel(){
            this.smodal=false
        },
        open(){
            
        },
        openmodal(){
            this.smodal=true
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/service.vue